import { useState } from 'react';
import { RowActionButton } from '@/components/common/RowActions';
import { showApiErrorToast } from '@/utils/errors';

interface BillButtonProps {
  onOpen: () => Promise<void>;
  label?: string;
  memberName?: string | null | undefined;
}

export function BillButton({ onOpen, label = 'Bill', memberName }: BillButtonProps) {
  const [isOpening, setIsOpening] = useState(false);

  async function handleClick() {
    setIsOpening(true);
    try {
      await onOpen();
    } catch (error) {
      showApiErrorToast(error, 'Could not open the bill');
    } finally {
      setIsOpening(false);
    }
  }

  return (
    <RowActionButton
      label={isOpening ? 'Opening…' : label}
      ariaLabel={
        memberName === null || memberName === undefined
          ? `${label}: the DCR Top Sheet`
          : `${label} for ${memberName}`
      }
      isDisabled={isOpening}
      onClick={() => void handleClick()}
    />
  );
}
